module.exports = __webpack_public_path__ + "static/img/bg_01.734e462.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_01.png
// module id = Ydyk
// module chunks = 1